import 'reflect-metadata';
import {Expose} from 'class-transformer';
import {
  IsBoolean,
  IsDateString,
  IsInt,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString, MaxLength,
  MinLength
} from 'class-validator';
import {Bid} from '../types';

export class AwardRfpToVendorDto implements Bid.AwardBidRequestData {

  @IsNumber()
  @IsPositive()
  @Expose()
  bidId = 0;

  @IsString()
  @MinLength(4)
  @MaxLength(250)
  @Expose()
  contractNumber = '';

  @IsString()
  @MaxLength(250)
  @Expose()
  contractTitle = '';

  private _contractValue = 0;

  get contractValue(): number {
    return this._contractValue;
  }

  @Expose()
  @IsNumber()
  @IsPositive()
  set contractValue(value: number) {
    console.log(`setting contractValue: ${value}`);
    this._contractValue = parseFloat((value + '').replace(/[^0-9.]/g, ''));
  }

  @IsBoolean()
  @Expose()
  keepBidOpen = false;

  @IsInt()
  @Expose()
  listId = 0;

  @IsDateString()
  @Expose()
  boardAwardDate: Date = new Date();

  @IsDateString()
  @Expose()
  estimatedStartDate: Date = new Date();

  @IsDateString()
  @Expose()
  estimatedFinishDate: Date = new Date();

  @IsBoolean()
  @Expose()
  isPsa: boolean = false;

  @IsString()
  @IsOptional()
  @Expose()
  wageDetermination?: string;
}

export class Contracts {
  public static Endpoints = {
    BaseRoute: 'projects'
  }
  public static Actions = {
    AwardContract: 'awardContract',
    UpdateContract: 'updateContract',
  }
  public static ModuleName = 'Contracts';
  public static Permissions = {
    ListContracts: 'Contracts:List',
    CreateContract: 'Contracts:Create',
    UpdateContract: 'Contracts:Update',
    DeleteContract: 'Contracts:Delete',
    ReadContract: 'Contracts:Read'
  }
}